import React, { Component } from 'react';
import axios from 'axios';

const instance = axios.create({
    baseURL: 'http://localhost:5000/api/',
    headers: {
      headerType: ''
    }
  })

export default class Axios extends Component {
  static propTypes = {

  };

  

  render() {
    return (
      <div className="home-axios">
        Component content: home/Axios
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/home/Axios.js